module.exports = __webpack_public_path__ + "static/media/crown.0e6755ae.svg";